/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'ptc.pm.collaborators.title': 'Je teamgenoten',
  'ptc.pm.error-heading': 'Er is iets misgegaan.',
  'ptc.pm.error-image-alt-text': 'Een defecte robot en een aantal mensen die bezig zijn hem te repareren.',
  'ptc.pm.error-text':
    'We houden deze fouten bij, maar aarzel niet om contact met ons op te nemen als pagina vernieuwen het probleem niet oplost.',
  'ptc.pm.num-members': '{memberCount, plural, one {{memberCount,number} lid} other {{memberCount,number} leden}}',
  'ptc.pm.people': 'Mensen',
  'ptc.pm.teams': 'Teams',
  'ptc.pm.view-your-profile': 'Je profiel bekijken',
  'ptc.pm.your-teams.title': 'Jouw teams',
};
